/**
=========================================================
* Sui UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Suiware.
*/
import React, { useState, useContext, useEffect } from "react";
import api from "services/api";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Sui UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import SuiBadge from "components/SuiBadge";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import IconButton from "@mui/material/IconButton";
import Prompt from "components/UpStyled/Prompt";

import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";

import toast from "react-hot-toast";
import moment from "moment";
import { useForm, Controller } from "react-hook-form";

import { AccountContext } from "context/account";

const CreateResponseTemplatePrompt = ({
  isEdit = false,
  template = null,
  visible,
  handleClose = () => {},
  handleOk = () => {},
}) => {
  const { metadata, handleUpdate } = useContext(AccountContext);

  const { register, handleSubmit, trigger, setValue, reset, control, getValues } = useForm();

  useEffect(() => {
    if (isEdit && template) {
      reset({
        title: template["title"],
        text: template["text"],
      });
    } else {
      reset({
        title: "Untitled",
        text: "",
      });
    }
  }, [isEdit]);

  return (
    <Prompt
      heading={`${isEdit ? "Edit" : "Create"} Response template`}
      option={{
        fullWidth: true,
        maxWidth: "sm",
      }}
      handleClose={handleClose}
      text={
        <SuiBox px={4} component="form" onSubmit={handleSubmit(handleOk)}>
          <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <SuiTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              required
              textTransform="capitalize"
            >
              Title
            </SuiTypography>
          </SuiBox>
          <SuiInput
            placeholder="A title for this template."
            type="text"
            inputProps={{ maxLength: 100 }}
            {...register("title", { required: true })}
          />
          <SuiBox my={1} ml={0.5} lineHeight={0} display="inline-block">
            <SuiTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Response Message
            </SuiTypography>
          </SuiBox>
          <SuiInput
            placeholder="Create your quick response template for the project here."
            {...register("text")}
            type="text"
            multiline
            maxRows={5}
            minRows={5}
          />
          <SuiBox display="flex" justifyContent="flex-end" gap={1} mt={2}>
            <SuiButton onClick={handleClose} color={"secondary"} variant="gradient">
              Cancel
            </SuiButton>
            <SuiButton type="submit" color={"info"} variant="gradient">
              {isEdit ? "Update" : "Create"}
            </SuiButton>
          </SuiBox>
        </SuiBox>
      }
      visible={visible}
      hideAction
    />
  );
};

export default CreateResponseTemplatePrompt;
